module.exports = __webpack_public_path__ + "static/media/quota-rejected.004ca4f0.png";